export default __webpack_public_path__ + "fc11e35f29ab8d97794876f209c8e63e.jpg";